import moment from 'moment';

import { shoppingCartService } from 'app/api/service/shopping-cart-service';
import { ActiveOrder } from 'app/page/orders/model/active-order';
import { ActiveOrdersMapper } from 'app/page/orders/mapper/active-orders-mapper';

class ShoppingCartService {
    public static readonly getAppointment = (
        partnerId: string,
        billingAccountId: string,
        servicePointId: string,
    ): Promise<OrderTrackerBackend.Appointment> =>
        shoppingCartService.getAppointment(partnerId, billingAccountId, servicePointId);

    public static readonly scheduleAppointment = (
        partnerId: string,
        billingAccountId: string,
        servicePointId: string,
        appointment: OrderTrackerBackend.Appointment,
    ): Promise<void> =>
        shoppingCartService.scheduleAppointment(partnerId, billingAccountId, servicePointId, appointment);

    public static readonly getAvailableAppointmentTime = (
        partnerId: string,
        billingAccountId: string,
        servicePointId: string,
        fromDate: moment.Moment,
    ): Promise<OrderTrackerBackend.DayTimeSlots[]> =>
        shoppingCartService.getAvailableAppointmentTime(partnerId, billingAccountId, servicePointId, fromDate);

    public static readonly getActiveOrders = (
        partnerId: string,
        billingAccountId: string,
    ): Promise<Record<string, ActiveOrder>> =>
        shoppingCartService.getInflightOrders(partnerId, billingAccountId).then(ActiveOrdersMapper.mapActiveOrders);

    public static readonly createOrderSummary = (
        partnerId: string,
        orderId: string,
    ): Promise<OrderTrackerBackend.OrderSummary> => shoppingCartService.createOrderSummary(partnerId, { orderId });

    public static readonly updateActivationDate = (
        partnerId: string,
        orderId: string,
        activationDate: string,
    ): Promise<void> =>
        shoppingCartService.updateActivationDate(partnerId, { orderId, requestedCompletionDate: activationDate });

    public static readonly getShoppingCart = (
        partnerId: string,
        cartId: string,
    ): Promise<OrderTrackerBackend.ShoppingCart> => shoppingCartService.getShoppingCart(partnerId, cartId);
}

export { ShoppingCartService };
